import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-shopping-cart-elbridge-two-button',
    templateUrl: './shopping-cart-elbridge-two-button.component.html',
    styleUrls: ['./shopping-cart-elbridge-two-button.component.scss'],
    standalone: false
})
export class ShoppingCartElbridgeTwoButtonComponent {
  @ViewChild('elbridgeForm') elbridgeFromEl: ElementRef;

  transferLink = environment.transferToElbridge2Link;
}
